import f from "../funcs";
import Events from "../classes/Events";


let Base = f.CreateClass("Base", {}, Events);

Base.prototype.init = function(system) {
    this.system = system;

    if ( f.isFunction(this.onInitSystem) ) {
        this.onInitSystem(system);
    }

    system.on("*", function(eventName) {
        let methodName = "on" + eventName[0].toUpperCase() + eventName.slice(1);
        let args = [].slice.call(arguments, 1);

        if ( f.isFunction(this[methodName]) ) {
            this[methodName].apply(this, args);
        }
    }.bind(this));
};

export default Base;
